module.exports = __webpack_public_path__ + "static/media/AI_bg.0b4f179a.jpg";